import { TableHead, styled } from '@mui/material';
export var StyledTableHead = styled(TableHead)(function (_a) {
    var theme = _a.theme;
    return ({});
});
//# sourceMappingURL=styled.js.map